import React, { useCallback, useMemo, useRef } from 'react';

import { CustomLink, CustomTooltip } from 'components/oldComponents';
import { RenderComponentProps } from 'components/oldComponents/DataTable/types';
import { resizeString } from 'utils';

const CustomTextLink: React.FC<RenderComponentProps> = ({
  value,
  context,
  row,
  maxTooltipSize,
  chartTooltipTitle,
  valueFormatter,
  maxStringLength = 30,
}) => {
  const tooltipRef = useRef(null);
  const { disabled, selectedItem } = context ?? {};

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();

      if (context && context.handleClick) {
        context.handleClick(row, value);
      }
    },
    [context, row, value],
  );

  const formattedValue = useMemo(() => {
    if (valueFormatter) {
      return valueFormatter(value, row);
    }

    return value;
  }, [valueFormatter, value, row]);

  return (
    <CustomTooltip
      ref={tooltipRef}
      showTitle={false}
      maxWidth={maxTooltipSize || 200}
      labelValue={chartTooltipTitle || formattedValue}
      showCircle={false}
      minWidth={maxTooltipSize || 200}
    >
      <CustomLink
        simplelink="true"
        color="primary"
        disabled={disabled}
        onClick={handleClick}
      >
        {context && selectedItem && selectedItem === row.id ? (
          <b>{resizeString(formattedValue, maxStringLength)}</b>
        ) : (
          resizeString(formattedValue, maxStringLength)
        )}
      </CustomLink>
    </CustomTooltip>
  );
};

export default CustomTextLink;
